import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { ActionMenu, ActionMenuItem, Checkbox, FormInput, Hint, Popover } from '@systemeio/ui';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { activateLecture, duplicateLecture, removeLecture, updateLecture } from 'modules/courses/courses/curriculum/api/lecture-api';
import { CourseCurriculumInterface } from 'modules/courses/courses/curriculum/types/curriculum-interface';
import { EditLectureErrorsInterface, EditLectureInterface, LectureInterface } from 'modules/courses/courses/curriculum/types/lecture-interface';
import { nonDraggableProps } from 'modules/courses/courses/curriculum/utils/non-draggable-props';
import { useRouter } from 'next/router';
import React, { memo, useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import EditModal from 'shared/components/edit-modal';
import { ActionMenuLinkItem } from 'shared/components/table/components/action-menu-link-item';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors';
import { KeyedMutator } from 'swr';
import { getCourseLectureAssignmentUrl } from '../../../../assignments/utils/get-course-lecture-assignment-url';
import { getCourseLectureEmailUrl } from '../../utils/get-course-lecture-email-url';
import { LectureEmailAction } from './lecture-email-action';
import { QuestionMarkIcon } from '@systemeio/ui/icons';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
interface LectureActionsProps {
  lecture: LectureInterface;
  mutate: KeyedMutator<CourseCurriculumInterface>;
  moduleId: number;
}
const defaultErrors: EditLectureErrorsInterface = {
  fields: {
    name: '',
    delayBeforePreviousLecture: ''
  }
};
function LectureActions(t0) {
  const $ = _c(174);
  const {
    lecture,
    mutate,
    moduleId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const router = useRouter();
  const {
    courseId
  } = router.query;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      method: RequestMethodsEnum.put
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    fetcher: putFetcher
  } = useFetch(t3);
  const assignmentFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.Assignment);
  const {
    revalidateModules
  } = useRevalidateModules();
  const [isCreateEmailOpen, setIsCreateEmailOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isActivateOpen, setIsActivateOpen] = useState(false);
  const [isDuplicateOpen, setIsDuplicateOpen] = useState(false);
  const [editErrors, setEditErrors] = useState(defaultErrors);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  let T0;
  let handleDuplicateLecture;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== assignmentFeatureIsOn || $[4] !== courseId || $[5] !== deleteFetcher || $[6] !== editErrors || $[7] !== isActivateOpen || $[8] !== isCreateEmailOpen || $[9] !== isRemoveOpen || $[10] !== isSettingsOpen || $[11] !== lecture || $[12] !== moduleId || $[13] !== mutate || $[14] !== postFetcher || $[15] !== putFetcher || $[16] !== revalidateModules || $[17] !== t) {
    const caption = t("dashboard.course.lecture_title").toLowerCase();
    const lectureId = lecture.id;
    let t15;
    if ($[31] !== lecture.active || $[32] !== lecture.id || $[33] !== lectureId || $[34] !== moduleId || $[35] !== mutate || $[36] !== postFetcher) {
      t15 = async () => {
        const update = lecture.active ? "deactivate" : "activate";
        await activateLecture(update, lecture.id, postFetcher);
        await mutate(data => {
          if (data) {
            return {
              ...data,
              modules: data.modules.map(module => {
                if (module.id === moduleId) {
                  return {
                    ...module,
                    lectures: module.lectures.map(lecture_0 => {
                      if (lecture_0.id === lectureId) {
                        return {
                          ...lecture_0,
                          active: !lecture_0.active
                        };
                      }
                      return lecture_0;
                    })
                  };
                }
                return module;
              })
            };
          }
        }, false);
      };
      $[31] = lecture.active;
      $[32] = lecture.id;
      $[33] = lectureId;
      $[34] = moduleId;
      $[35] = mutate;
      $[36] = postFetcher;
      $[37] = t15;
    } else {
      t15 = $[37];
    }
    const handleActivateLecture = t15;
    let t16;
    if ($[38] !== lecture.id || $[39] !== moduleId || $[40] !== mutate || $[41] !== postFetcher || $[42] !== revalidateModules) {
      t16 = async () => {
        const response = await duplicateLecture(lecture.id, postFetcher);
        await mutate(data_0 => {
          if (data_0) {
            return {
              ...data_0,
              modules: data_0.modules.map(module_0 => {
                if (module_0.id === moduleId) {
                  const lectureIndex = module_0.lectures.findIndex(t17 => {
                    const {
                      id
                    } = t17;
                    return lecture.id === id;
                  });
                  const lectures = [...module_0.lectures];
                  lectures.splice(lectureIndex + 1, 0, {
                    ...response
                  });
                  return {
                    ...module_0,
                    lectures
                  };
                }
                return module_0;
              })
            };
          }
        }, false);
        await revalidateModules([RequestModuleEnum.MembershipCourseLecture]);
      };
      $[38] = lecture.id;
      $[39] = moduleId;
      $[40] = mutate;
      $[41] = postFetcher;
      $[42] = revalidateModules;
      $[43] = t16;
    } else {
      t16 = $[43];
    }
    handleDuplicateLecture = t16;
    let t17;
    if ($[44] !== deleteFetcher || $[45] !== lectureId || $[46] !== moduleId || $[47] !== mutate || $[48] !== revalidateModules) {
      t17 = async () => {
        await removeLecture(lectureId, deleteFetcher);
        await mutate(data_1 => {
          if (data_1) {
            return {
              ...data_1,
              modules: data_1.modules.map(module_1 => {
                if (module_1.id === moduleId) {
                  return {
                    ...module_1,
                    lectures: module_1.lectures.filter(lecture_1 => lecture_1.id !== lectureId)
                  };
                }
                return module_1;
              })
            };
          }
        }, false);
        await revalidateModules([RequestModuleEnum.MembershipCourseLecture]);
      };
      $[44] = deleteFetcher;
      $[45] = lectureId;
      $[46] = moduleId;
      $[47] = mutate;
      $[48] = revalidateModules;
      $[49] = t17;
    } else {
      t17 = $[49];
    }
    const handleRemoveLecture = t17;
    let t18;
    if ($[50] !== lectureId || $[51] !== moduleId || $[52] !== mutate || $[53] !== putFetcher || $[54] !== revalidateModules) {
      t18 = async data_2 => {
        await fetchWithFieldErrors(async () => {
          const response_0 = await updateLecture(lectureId, data_2, putFetcher);
          await mutate(data_3 => {
            if (data_3) {
              return {
                ...data_3,
                modules: data_3.modules.map(module_2 => {
                  if (module_2.id === moduleId) {
                    return {
                      ...module_2,
                      lectures: module_2.lectures.map(lecture_2 => {
                        if (lecture_2.id === lectureId) {
                          return response_0;
                        }
                        return lecture_2;
                      })
                    };
                  }
                  return module_2;
                })
              };
            }
          }, false);
        }, setEditErrors);
        await revalidateModules([RequestModuleEnum.MembershipCourseLecture]);
      };
      $[50] = lectureId;
      $[51] = moduleId;
      $[52] = mutate;
      $[53] = putFetcher;
      $[54] = revalidateModules;
      $[55] = t18;
    } else {
      t18 = $[55];
    }
    const handleEditLecture = t18;
    t14 = "flex items-center justify-end";
    t9 = nonDraggableProps;
    let t19;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = {
        "data-test": "module-lecture-actions"
      };
      $[56] = t19;
    } else {
      t19 = $[56];
    }
    let t20;
    if ($[57] !== lecture.active || $[58] !== t) {
      t20 = lecture.active ? t("dashboard.actions.title.deactivate") : t("dashboard.actions.title.activate");
      $[57] = lecture.active;
      $[58] = t;
      $[59] = t20;
    } else {
      t20 = $[59];
    }
    let t21;
    let t22;
    if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = () => {
        setIsActivateOpen(true);
      };
      t22 = {
        "data-test": "module-lecture-action-status"
      };
      $[60] = t21;
      $[61] = t22;
    } else {
      t21 = $[60];
      t22 = $[61];
    }
    let t23;
    if ($[62] !== t20) {
      t23 = <ActionMenuItem key="action-activate" label={t20} onClick={t21} dataTestAttributes={t22} />;
      $[62] = t20;
      $[63] = t23;
    } else {
      t23 = $[63];
    }
    let t24;
    if ($[64] !== t) {
      t24 = t("dashboard.actions.title.edit");
      $[64] = t;
      $[65] = t24;
    } else {
      t24 = $[65];
    }
    let t25;
    if ($[66] !== lecture.pageId) {
      t25 = getPageEditorUrl(lecture.pageId);
      $[66] = lecture.pageId;
      $[67] = t25;
    } else {
      t25 = $[67];
    }
    let t26;
    if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = {
        "data-test": "module-lecture-action-edit"
      };
      $[68] = t26;
    } else {
      t26 = $[68];
    }
    let t27;
    if ($[69] !== t24 || $[70] !== t25) {
      t27 = <ActionMenuLinkItem key="action-edit" label={t24} href={t25} dataTestAttributes={t26} />;
      $[69] = t24;
      $[70] = t25;
      $[71] = t27;
    } else {
      t27 = $[71];
    }
    let t28;
    if ($[72] !== t) {
      t28 = t("dashboard.actions.title.open");
      $[72] = t;
      $[73] = t28;
    } else {
      t28 = $[73];
    }
    let t29;
    if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
      t29 = {
        "data-test": "module-lecture-action-view"
      };
      $[74] = t29;
    } else {
      t29 = $[74];
    }
    let t30;
    if ($[75] !== lecture.loginLinkUrl || $[76] !== t28) {
      t30 = <ActionMenuLinkItem key="action-open" label={t28} href={lecture.loginLinkUrl} openInNew={true} dataTestAttributes={t29} />;
      $[75] = lecture.loginLinkUrl;
      $[76] = t28;
      $[77] = t30;
    } else {
      t30 = $[77];
    }
    let t31;
    if ($[78] !== t) {
      t31 = t("dashboard.actions.title.settings");
      $[78] = t;
      $[79] = t31;
    } else {
      t31 = $[79];
    }
    let t32;
    let t33;
    if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
      t32 = () => {
        setIsSettingsOpen(true);
      };
      t33 = {
        "data-test": "module-lecture-action-settings"
      };
      $[80] = t32;
      $[81] = t33;
    } else {
      t32 = $[80];
      t33 = $[81];
    }
    let t34;
    if ($[82] !== t31) {
      t34 = <ActionMenuItem key="action-settings" label={t31} onClick={t32} dataTestAttributes={t33} />;
      $[82] = t31;
      $[83] = t34;
    } else {
      t34 = $[83];
    }
    let t35;
    if ($[84] !== assignmentFeatureIsOn || $[85] !== courseId || $[86] !== lecture.hasAssignmentSettings || $[87] !== lecture.id || $[88] !== t) {
      t35 = assignmentFeatureIsOn && (lecture.hasAssignmentSettings ? <ActionMenuLinkItem key="action-edit-assignment" label={t("dashboard.course.lecture.actions.edit_assignment")} isNext={true} href={getCourseLectureAssignmentUrl({
        courseId: Number(courseId as string),
        lectureId: lecture.id,
        hasAssignmentSettings: lecture.hasAssignmentSettings
      })} /> : <ActionMenuLinkItem key="action-create-assignment" label={t("dashboard.course.lecture.actions.create_assignment")} isNext={true} href={getCourseLectureAssignmentUrl({
        courseId: Number(courseId as string),
        lectureId: lecture.id,
        hasAssignmentSettings: lecture.hasAssignmentSettings
      })} />);
      $[84] = assignmentFeatureIsOn;
      $[85] = courseId;
      $[86] = lecture.hasAssignmentSettings;
      $[87] = lecture.id;
      $[88] = t;
      $[89] = t35;
    } else {
      t35 = $[89];
    }
    let t36;
    if ($[90] !== courseId || $[91] !== lecture.currentEmail?.id || $[92] !== lecture.id || $[93] !== t) {
      t36 = lecture.currentEmail?.id ? <ActionMenuLinkItem key="action-edit-drip" label={t("dashboard.course.lecture.actions.edit_drip")} isNext={true} href={getCourseLectureEmailUrl({
        courseId: Number(courseId as string),
        lectureId: lecture.id
      })} dataTestAttributes={{
        "data-test": "module-lecture-action-edit-drip"
      }} /> : <ActionMenuItem key="action-create-drip" label={<div className="[&>svg]:fill-brand-primary [&>svg]:main-transition-colors flex items-center gap-3">{t("dashboard.course.lecture.actions.create_drip")}<Popover label={t("dashboard.course.lecture.actions.create_drip_popover")} popoverClassName="w-[200px] sm:w-[300px] z-[99999]">{_temp}</Popover></div>} onClick={() => {
        setIsCreateEmailOpen(true);
      }} dataTestAttributes={{
        "data-test": "module-lecture-action-create-drip"
      }} />;
      $[90] = courseId;
      $[91] = lecture.currentEmail?.id;
      $[92] = lecture.id;
      $[93] = t;
      $[94] = t36;
    } else {
      t36 = $[94];
    }
    let t37;
    if ($[95] !== t) {
      t37 = t("dashboard.actions.title.duplicate");
      $[95] = t;
      $[96] = t37;
    } else {
      t37 = $[96];
    }
    let t38;
    let t39;
    if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
      t38 = () => {
        setIsDuplicateOpen(true);
      };
      t39 = {
        "data-test": "module-lecture-action-duplicate"
      };
      $[97] = t38;
      $[98] = t39;
    } else {
      t38 = $[97];
      t39 = $[98];
    }
    let t40;
    if ($[99] !== t37) {
      t40 = <ActionMenuItem key="action-duplicate" label={t37} onClick={t38} dataTestAttributes={t39} />;
      $[99] = t37;
      $[100] = t40;
    } else {
      t40 = $[100];
    }
    let t41;
    if ($[101] !== t) {
      t41 = t("dashboard.actions.title.remove");
      $[101] = t;
      $[102] = t41;
    } else {
      t41 = $[102];
    }
    let t42;
    let t43;
    if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
      t42 = () => {
        setIsRemoveOpen(true);
      };
      t43 = {
        "data-test": "module-lecture-action-remove"
      };
      $[103] = t42;
      $[104] = t43;
    } else {
      t42 = $[103];
      t43 = $[104];
    }
    let t44;
    if ($[105] !== t41) {
      t44 = <ActionMenuItem key="action-remove" label={t41} onClick={t42} dataTestAttributes={t43} />;
      $[105] = t41;
      $[106] = t44;
    } else {
      t44 = $[106];
    }
    if ($[107] !== t23 || $[108] !== t27 || $[109] !== t30 || $[110] !== t34 || $[111] !== t35 || $[112] !== t36 || $[113] !== t40 || $[114] !== t44) {
      t10 = <ActionMenu dataTestAttributes={t19} menuItems={[t23, t27, t30, t34, t35, t36, t40, t44]} />;
      $[107] = t23;
      $[108] = t27;
      $[109] = t30;
      $[110] = t34;
      $[111] = t35;
      $[112] = t36;
      $[113] = t40;
      $[114] = t44;
      $[115] = t10;
    } else {
      t10 = $[115];
    }
    let t45;
    if ($[116] === Symbol.for("react.memo_cache_sentinel")) {
      t45 = () => setIsCreateEmailOpen(false);
      $[116] = t45;
    } else {
      t45 = $[116];
    }
    if ($[117] !== isCreateEmailOpen || $[118] !== lecture) {
      t11 = <LectureEmailAction lecture={lecture} isOpened={isCreateEmailOpen} onClose={t45} />;
      $[117] = isCreateEmailOpen;
      $[118] = lecture;
      $[119] = t11;
    } else {
      t11 = $[119];
    }
    let t46;
    if ($[120] !== t) {
      t46 = t("dashboard.course.lecture_edit_settings_title");
      $[120] = t;
      $[121] = t46;
    } else {
      t46 = $[121];
    }
    let t47;
    if ($[122] === Symbol.for("react.memo_cache_sentinel")) {
      t47 = () => {
        setIsSettingsOpen(false);
      };
      $[122] = t47;
    } else {
      t47 = $[122];
    }
    let t48;
    if ($[123] !== editErrors || $[124] !== lecture.id || $[125] !== t) {
      t48 = {
        field: "name",
        onRender: (value, onChange) => <FormInput value={value} key={`${lecture.id}-name`} onChange={e => onChange(e.target.value)} label={t("global.name")} error={editErrors.fields.name} />
      };
      $[123] = editErrors;
      $[124] = lecture.id;
      $[125] = t;
      $[126] = t48;
    } else {
      t48 = $[126];
    }
    let t49;
    if ($[127] !== editErrors || $[128] !== lecture.id || $[129] !== t) {
      t49 = {
        field: "delayBeforePreviousLecture",
        onRender: (value_0, onChange_0) => <FormInput value={value_0} key={`${lecture.id}-delayBeforePreviousLecture`} type="number" onChange={e_0 => onChange_0(parseInt(e_0.target.value))} label={<Hint label={t("dashboard.course.lecture_delay_title_tooltip")}>{t("dashboard.course.lecture_delay_title")}</Hint>} error={editErrors.fields.delayBeforePreviousLecture} />
      };
      $[127] = editErrors;
      $[128] = lecture.id;
      $[129] = t;
      $[130] = t49;
    } else {
      t49 = $[130];
    }
    let t50;
    if ($[131] !== moduleId || $[132] !== t) {
      t50 = {
        field: "showComments",
        onRender: (value_1, onChange_1) => <Checkbox key={`${moduleId}-showComments`} label={t("dashboard.course.show_comments_title")} value={value_1} onChange={onChange_1} />
      };
      $[131] = moduleId;
      $[132] = t;
      $[133] = t50;
    } else {
      t50 = $[133];
    }
    let t51;
    if ($[134] !== t48 || $[135] !== t49 || $[136] !== t50) {
      t51 = [t48, t49, t50];
      $[134] = t48;
      $[135] = t49;
      $[136] = t50;
      $[137] = t51;
    } else {
      t51 = $[137];
    }
    if ($[138] !== handleEditLecture || $[139] !== isSettingsOpen || $[140] !== lecture || $[141] !== t46 || $[142] !== t51) {
      t12 = <EditModal fullCaption={t46} opened={isSettingsOpen} onClose={t47} instance={lecture} editable={t51} onEdit={handleEditLecture} />;
      $[138] = handleEditLecture;
      $[139] = isSettingsOpen;
      $[140] = lecture;
      $[141] = t46;
      $[142] = t51;
      $[143] = t12;
    } else {
      t12 = $[143];
    }
    let t52;
    if ($[144] === Symbol.for("react.memo_cache_sentinel")) {
      t52 = () => setIsRemoveOpen(false);
      $[144] = t52;
    } else {
      t52 = $[144];
    }
    t13 = <Confirmation opened={isRemoveOpen} onClose={t52} onConfirm={handleRemoveLecture} confirmationText={t("dashboard.actions.remove_confirmation", {
      module: caption?.toLowerCase()
    })} toastCaption={t("dashboard.actions.removed", {
      module: caption
    })} />;
    T0 = Confirmation;
    t4 = isActivateOpen;
    if ($[145] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = () => setIsActivateOpen(false);
      $[145] = t5;
    } else {
      t5 = $[145];
    }
    t6 = handleActivateLecture;
    t7 = t("dashboard.actions.activate_confirmation", {
      activate: lecture.active ? t("global.deactivate").toLowerCase() : t("global.activate").toLowerCase(),
      module: caption?.toLowerCase()
    });
    t8 = t("dashboard.actions.activated", {
      module: caption,
      activated: lecture.active ? t("dashboard.actions.deactivated_caption").toLowerCase() : t("dashboard.actions.activated_caption").toLowerCase()
    });
    $[3] = assignmentFeatureIsOn;
    $[4] = courseId;
    $[5] = deleteFetcher;
    $[6] = editErrors;
    $[7] = isActivateOpen;
    $[8] = isCreateEmailOpen;
    $[9] = isRemoveOpen;
    $[10] = isSettingsOpen;
    $[11] = lecture;
    $[12] = moduleId;
    $[13] = mutate;
    $[14] = postFetcher;
    $[15] = putFetcher;
    $[16] = revalidateModules;
    $[17] = t;
    $[18] = T0;
    $[19] = handleDuplicateLecture;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    T0 = $[18];
    handleDuplicateLecture = $[19];
    t10 = $[20];
    t11 = $[21];
    t12 = $[22];
    t13 = $[23];
    t14 = $[24];
    t4 = $[25];
    t5 = $[26];
    t6 = $[27];
    t7 = $[28];
    t8 = $[29];
    t9 = $[30];
  }
  let t15;
  if ($[146] !== T0 || $[147] !== t4 || $[148] !== t5 || $[149] !== t6 || $[150] !== t7 || $[151] !== t8) {
    t15 = <T0 opened={t4} onClose={t5} onConfirm={t6} confirmationText={t7} toastCaption={t8} />;
    $[146] = T0;
    $[147] = t4;
    $[148] = t5;
    $[149] = t6;
    $[150] = t7;
    $[151] = t8;
    $[152] = t15;
  } else {
    t15 = $[152];
  }
  let t16;
  if ($[153] !== t) {
    t16 = t("dashboard.course.lecture_duplicate_title");
    $[153] = t;
    $[154] = t16;
  } else {
    t16 = $[154];
  }
  let t17;
  if ($[155] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => setIsDuplicateOpen(false);
    $[155] = t17;
  } else {
    t17 = $[155];
  }
  let t18;
  if ($[156] !== t) {
    t18 = t("dashboard.course.lecture_duplicated_title");
    $[156] = t;
    $[157] = t18;
  } else {
    t18 = $[157];
  }
  let t19;
  if ($[158] !== handleDuplicateLecture || $[159] !== isDuplicateOpen || $[160] !== t16 || $[161] !== t18) {
    t19 = <Confirmation confirmationText={t16} opened={isDuplicateOpen} onClose={t17} onConfirm={handleDuplicateLecture} toastCaption={t18} />;
    $[158] = handleDuplicateLecture;
    $[159] = isDuplicateOpen;
    $[160] = t16;
    $[161] = t18;
    $[162] = t19;
  } else {
    t19 = $[162];
  }
  let t20;
  if ($[163] !== t10 || $[164] !== t11 || $[165] !== t12 || $[166] !== t13 || $[167] !== t15 || $[168] !== t19 || $[169] !== t9) {
    t20 = <div {...t9}>{t10}{t11}{t12}{t13}{t15}{t19}</div>;
    $[163] = t10;
    $[164] = t11;
    $[165] = t12;
    $[166] = t13;
    $[167] = t15;
    $[168] = t19;
    $[169] = t9;
    $[170] = t20;
  } else {
    t20 = $[170];
  }
  let t21;
  if ($[171] !== t14 || $[172] !== t20) {
    t21 = <div className={t14}>{t20}</div>;
    $[171] = t14;
    $[172] = t20;
    $[173] = t21;
  } else {
    t21 = $[173];
  }
  return t21;
}
function _temp(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
export default memo(LectureActions);